import type { UseMutationOptions, UseMutationResult } from "@tanstack/react-query";
import { useMutation } from "@tanstack/react-query";
import client from "@/api/client/axios";
import type { ResponseConfig } from "@/api/client/axios";
import type { PickWinnerBidsMutationRequest, PickWinnerBidsMutationResponse, PickWinnerBidsQueryParams, PickWinnerBids400, PickWinnerBids401, PickWinnerBids403, PickWinnerBids422, PickWinnerBids429, PickWinnerBids500 } from "../types/PickWinnerBids";

/**
 * @link /api/purchase-tenders/v1/bids/pick_winner-bids
 */

export function usePickWinnerBids <TData = PickWinnerBidsMutationResponse, TError = PickWinnerBids400 | PickWinnerBids401 | PickWinnerBids403 | PickWinnerBids422 | PickWinnerBids429 | PickWinnerBids500, TVariables = PickWinnerBidsMutationRequest>(params: PickWinnerBidsQueryParams, options: {
          mutation?: UseMutationOptions<ResponseConfig<TData>, TError, TVariables>,
          client?: Partial<Parameters<typeof client<TData, TError, TVariables>>[0]>,
      } = {}): UseMutationResult<ResponseConfig<TData>, TError, TVariables> {
  const { mutation: mutationOptions, client: clientOptions = {} } = options ?? {};

  return useMutation<ResponseConfig<TData>, TError, TVariables>({
    mutationFn: (data) => {
      
      return client<TData, TError, TVariables>({
        method: "post",
        url: `/api/purchase-tenders/v1/bids/pick_winner-bids`,
        data,
        params,
        
        ...clientOptions
      });
    },
    ...mutationOptions
  });
};
